import { render, staticRenderFns } from "./PerfisInfoAlert.vue?vue&type=template&id=2a683cce&scoped=true&"
import script from "./PerfisInfoAlert.vue?vue&type=script&lang=js&"
export * from "./PerfisInfoAlert.vue?vue&type=script&lang=js&"
import style0 from "./PerfisInfoAlert.vue?vue&type=style&index=0&id=2a683cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a683cce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
